import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";

export type IdentityVerificationSessionResponse = {
  client_secret: string;
};

// POST /api/identity/verification-session
export async function createOrReuseIdentityVerificationSession() {
  const options = setHeaderOptions({ method: "POST" });
  return fetchData<IdentityVerificationSessionResponse>(
    `${ApiEndpoints.identity}/verification-session`,
    options
  );
}

export type IdentityVerificationStatus =
  | "requires_input"
  | "processing"
  | "verified"
  | "canceled"
  | "unknown";

export type IdentityVerificationRecord = {
  id?: string;
  status: IdentityVerificationStatus;
  updated_at?: string | null;
};

// GET /api/identity/verification-session (assumed) → { data: { status, id, updated_at } }
export async function getIdentityVerificationStatus() {
  const options = setHeaderOptions({ method: "GET" });
  return fetchData<IdentityVerificationRecord>(
    `${ApiEndpoints.identity}/status`,
    options
  );
}
